import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { IC_ARROW, IC_FILTER_GREEN, IC_SHARE } from '../../Assets/images';
import { DropdownControl, CheckboxControl } from '../Forms/index';
import { BlankCardStyled } from './BlankCardStyled';
import ShareProduct from 'Epharmacy/ProductDetails/ShareProduct';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const BlankCard = (props) => {
  const ref = useRef();
  const generateURL = useNavigationURL();
  const [isClickOnShare, setClickOnShare] = React.useState(false);

  React.useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isClickOnShare && ref.current && !ref.current.contains(e.target)) {
        setClickOnShare(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isClickOnShare]);

  return (
    <BlankCardStyled
      className={[props?.customClass, props?.withShadow ? 'withShadow' : '', props?.noTitleBar ? 'noTitleBar' : '']}
    >
      {!props?.noTitleBar  && (
        <div className="w-100 d-flex align-items-center justify-content-between">
          <div
            className={`titleBar ${props?.border === true ? 'borderBottom' : ''} ${props?.hideDetails === true ? 'd-none' : ''
              } ${props?.mergeshipment ? 'align-items-center' : ''}`}
          >
            <h2 className={`title ${props?.showTitleinQuote ? 'notruncet' : ''}`}>
              {props?.arrowimage && (
                <span
                  className="arrow-icon cursor-pointer"
                  onClick={
                    props?.isFromDoctor
                      ? () =>
                          router.push({
                            pathname: generateURL(`${TELECONSULT_ROUTE}/speciality-list`),
                          })
                      : props?.onClick
                  }
                >
                  <Image src={IC_ARROW} alt=""></Image>
                </span>
              )}

              <span title={props?.title}>
                <span className="light-text">{props?.lightTextTitle}</span>
                {!props?.forH1TitleRender && (
                  <>
                    {props?.showTitleinQuote && props?.title !== '' ? (
                      <>
                        {'"'}
                        <span className="quotedtext">{props?.title}</span>
                        {'"'}
                      </>
                    ) : (
                      props?.title
                    )}
                  </>
                )}
                {props?.forH1TitleRender && <h1 className="facility-title">{props?.title}</h1>}
              </span>
              {props?.subTitle && <div className="sub-title">{props?.subTitleText}</div>}
            </h2>
            {props?.shareIcon && (
              <div ref={ref}>
                <div className="share-tost">
                  <div className="filter">
                    <div className="ic">
                      <Image
                        data-test="shareIcon"
                        src={IC_SHARE.src}
                        width="18px"
                        height="20px"
                        alt="Share"
                        onClick={() => {
                          setClickOnShare(!isClickOnShare);
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                    {isClickOnShare && <ShareProduct facilityName={props?.title} isFromFacility={true} />}
                  </div>
                </div>
              </div>
            )}
            {props?.rightpanel && (
              <div className="dropdown-container me-3">
                <label className="dropdown-label">{props.rightlabel}</label>
                <DropdownControl
                  data={props.sortNameListData}
                  caption={props.selectedValue}
                  handleSelect={(value) => {
                    props?.handleSort(value);
                  }}
                  theme={props?.rightpanelTheme}
                />

                {props?.showFilterForPLP ? (
                  <div className="noDesktop showFilter" onClick={props?.setIsOpen}>
                    <Image src={IC_FILTER_GREEN} alt="" layout="fill" />
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
            {props?.mergeshipment && (
              <div className="mergeShipmentWrapper">
                <CheckboxControl
                  label="Merge Two Shipments Together"
                  name="facilityName"
                  id="facilityName"
                  appVariant="epharmacy"
                  onChange={(value) => props?.onCheckbox(value)}
                />
                <div className="deliveryTime">{props?.deliveryText}</div>
              </div>
            )}
            {props?.rightData && <div className="rightSide">{props?.rightData}</div>}
          </div>
          <>
            {props.imgBox && (
              <span
                className={`img-wrapper min-80 d-flex cursor-pointer ${props?.downloadIconForGuestUser ? 'guestFlowRecords' : ''}`}
                data-test="click1"
                onClick={() => {
                  props.handleBlueTextClick();
                }}
              >
                <Image
                  src={props?.imgSrc}
                  alt="error"
                  width={props?.downloadIconForGuestUser ? 38 : 20}
                  height={props?.downloadIconForGuestUser ? 38 : 20}
                />
                <div className="blue-text">{props.blueText}</div>
              </span>
            )}
            {props.imgSecond && (
              <div ref={ref}>
                <span className="img-wrapper d-flex pe-3">
                  <div className="share-tost">
                    <div className="filter">
                      <div className="ic">
                        <Image
                          data-test="shareIcon"
                          src={props?.imgSrcSecond}
                          width="20px"
                          height="20px"
                          alt="Share icon"
                          onClick={() => {
                            setClickOnShare(!isClickOnShare);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      {isClickOnShare && <ShareProduct facilityName={props?.title} isFromFacility={true} isFromRecords/>}
                    </div>
                  </div>
                </span>
              </div>
            )}
          </>
        </div>
      )}
      <>{props.children}</>
    </BlankCardStyled>
  );
};

BlankCard.propTypes = {
  customClass: PropTypes.string,
  children: PropTypes.any,
  title: PropTypes.string,
  titleBar: PropTypes.bool,
  blueText: PropTypes.string,
  arrowimage: PropTypes.any,
  rightpanel: PropTypes.any,
  mergeshipment: PropTypes.any,
  rightlabel: PropTypes.string,
  border: PropTypes.any,
  imgBox: PropTypes.bool,
  imgSrc: PropTypes.any,
  subTitle: PropTypes.bool,
  subTitleText: PropTypes.string,
  onClick: PropTypes.func,
  onCheckbox: PropTypes.func,
  handleSort: PropTypes.func,
  sortNameListData: PropTypes.object,
  selectedValue: PropTypes.string,
  handleBlueTextClick: PropTypes.any,
  rightData: PropTypes.any,
  imgSecond: PropTypes.any,
  imgSrcSecond: PropTypes.any,
  lightTextTitle: PropTypes.string,
  showFilterForPLP: PropTypes.bool,
  setIsOpen: PropTypes.func,
  showTitleinQuote: PropTypes.bool,
  hideDetails: PropTypes.bool,
  deliveryText: PropTypes.any,
  withShadow: PropTypes.bool,
  noTitleBar: PropTypes.bool,
  rightpanelTheme: PropTypes.string,
  isFromFacilityDetail: PropTypes.bool,
  forH1TitleRender: PropTypes.bool,
};

BlankCard.defaultProps = {
  customClass: '',
  title: '',
  titleBar: true,
  arrowimage: '',
  rightpanel: '',
  rightlabel: '',
  border: '',
  subTitle: false,
  imgSecond: '',
  imgSrcSecond: '',
  lightTextTitle: '',
  hideDetails: false,
  // setIsOpen: '',
  showFilterForPLP: false,
  showTitleinQuote: false,
  withShadow: false,
  noTitleBar: false,
  rightpanelTheme: '',
  isFromFacilityDetail: false,
  forH1TitleRender: false,
};

export default BlankCard;
